import { NotificationToast } from '@cuemath/web-comps';
import { hideToast } from 'actions/toast-msg';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

function NotificationToastContainer() {
  const appStoreData = useSelector(store => store.toastMessage);
  const dispatch = useDispatch();

  const { message, ctaList, timeout, toastMetaData } = appStoreData || {};

  const onHideToast = () => {
    dispatch(hideToast());
  };

  return (
    <NotificationToast
      message={message}
      ctaList={ctaList}
      hideToast={onHideToast}
      timeout={timeout}
      toastMetaData={toastMetaData}
    />
  );
}

export default NotificationToastContainer;
